import { LoaderService } from './shared/service/loader.service';
import { globalService } from './shared/service/global.service';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from './shared/service/data.service';
import { HttpClient } from '@angular/common/http';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'asago';
  isLoading: boolean = false;
  svgIcons = ['wizard0','wizard1' , 'wizard2' , 'wizard3', 'wizard4' , 'wizard5' , 'wizard6', 'wizard7'] ;
  constructor(
    public globServ: globalService, 
    private translate: TranslateService, 
    private http: HttpClient,
    private loader:LoaderService,
     private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
    ) {
    let token = localStorage.getItem('sha_token');
    let type = localStorage.getItem('loginType');
    let asagoDefaultUserLang = localStorage.getItem('asagoDefaultUserLang');
    this.globServ.shaToken = token ? token : '';
    this.globServ.loginMode = type ? type : '';
    this.globServ.setLang(asagoDefaultUserLang ? asagoDefaultUserLang : 'de');
    
    this.translate.setDefaultLang('de');
    this.translate.addLangs(['de', 'en', 'fr']);
  }

  ngOnInit() {
    this.loader.ladIndicator.subscribe(response => {
      this.isLoading = response;
    })
     if (this.svgIcons?.length > 0) {
      this.svgIcons.map((icon, index) => {
        this.iconRegistry.addSvgIcon(
          icon,
          this.sanitizer.bypassSecurityTrustResourceUrl(
           `assets/icons/${icon}.svg`
          )
        );
      });
    }
      // this.isLoading = false;
      // this.getLanguageData()
  }

  // getLanguageData() {
  //   this.http.get('http://82.165.76.209:8057/administrative.svc/GetProjectTranslation?projectid=11').subscribe((response: any) => {
      
  //     this.translate.setTranslation('de', JSON.parse(response.d.DE), true)
  //     this.translate.setTranslation('en', JSON.parse(response.d.EN), true)
  //     this.translate.setTranslation('fr', JSON.parse(response.d.FR), true)
      
        
  //     this.translate.use('en');
  //   })
  // }

  // initLanguageSetup() {

  //   this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
  //     if(event.lang != this.lang_select.value) {
  //       this.lang_select.setValue(event.lang, {emitEvent: false});
  //     }
  //   });
  //   this.getCurrentUserLanguage();
  //   this.lang_select.valueChanges.subscribe(value => {
  //     if(this._serv.checkForNull(value)){
  //       this.lang_select.setValue('en', {emitEvent: false});
  //     }
  //     this.translate.setDefaultLang(this.lang_select.value);
  //     this.setCurrentPrefferedLanguage(this.lang_select.value);
  //   })
  // }
}
